import ModelTypeConstants from 'constants/ModelTypeConstants';

export default function areSelectedTypesExactly(
  selectedTypes: Array<string>,
  expectedTypes: Array<string>
): boolean {
  return (
    selectedTypes.length === expectedTypes.length &&
    selectedTypes.every((type) => expectedTypes.includes(type))
  );
}

export function areSelectedTypesSubset(selectedTypes: Array<string>, expectedTypes: Array<string>): boolean {
  return selectedTypes.every((type) => expectedTypes.includes(type));
}

export function areSelectedTypesTaskTypes(selectedTypes: Array<string>): boolean {
  return selectedTypes.every((value) =>
    (
      [
        ModelTypeConstants.ASSAY_RUN_TASK,
        ModelTypeConstants.ASSAY_STEP_TASK,
        ModelTypeConstants.ASSAY_UNIT_OPERATION_TASK,
        ModelTypeConstants.PROCESS_TASK,
        ModelTypeConstants.RECIPE_RUN_TASK,
        ModelTypeConstants.RECIPE_STEP_TASK,
        ModelTypeConstants.RECIPE_UNIT_OPERATION_TASK,
      ] as Array<string>
    ).includes(value)
  );
}
